// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__27Pp1","list":"BalanceDue_list__3K92J","listRow":"BalanceDue_listRow__3553-","total":"BalanceDue_total__ppw8w"};